import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_chkchzbnrw: FaireBrandEntity = {
  token: "b_chkchzbnrw",
  type: "brand",
  name: "Subtle & Wild",
  avatarUrl:
    "https://cdn.faire.com/fastly/40eadee1676c97d35997948a7bddeab2812a4595b1b4255c07afb631a5003f15.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c74b73fd1885a08055db49084dd9835902bc716eac6e5c4d8ca974c8d2f94496.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/40eadee1676c97d35997948a7bddeab2812a4595b1b4255c07afb631a5003f15.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c74b73fd1885a08055db49084dd9835902bc716eac6e5c4d8ca974c8d2f94496.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 50,
  rating: 4.5,
  reviewCount: 66,
  isInsider: true,
  description:
    "Over 400+ boutiques and brick-and-mortar stores served on Faire. Our products feature all organic and natural ingredients which are all handmade in small batches to maintain quality. We curate our fragrances and products based on the season. Please check back weekly for new products and sales.  **All private label items come without logos or branding** You can create your own at avery.com",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:31.270Z",
    importedBy: "entity-db-cli",
  },
};
